import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

const SHADOW = "0 2px 15px 0 rgba(0, 0, 0, 0.15)";

export const list = css`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const floatingOverlay = (theme: ExactTheme) => ({
  zIndex: theme.zIndices.dropdowns,
});

export const floatingContainer = (theme: ExactTheme) => css`
  border-radius: ${theme.borderRadiusV2.primary};
  overflow: hidden;
  background-color: white;
  font-size: ${theme.fontSizes[1]};
  font-weight: ${theme.fontWeights.normal};
  box-shadow: ${SHADOW};
  outline: none;
  display: flex;
  flex-direction: column;
`;

export const listItem = () => (theme: ExactTheme) => css`
  display: flex;
  user-select: none;
  flex-shrink: 0;
  //transition: background-color 0.15s;
  color: ${theme.colorsV2.grey[800]};
  font-weight: ${theme.fontWeights.normal};
  padding: 5px 10px;
  align-items: center;
  height: 35px;

  font-size: inherit;
  border-bottom: 1px solid ${theme.colorsV2.grey[100]};

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${theme.colorsV2.grey[50]};
  }

  background-color: transparent;
  cursor: pointer;
`;
